import { IonContent, IonPage } from '@ionic/react';
import { Link } from 'react-router-dom';

// T-267: la registrazione pubblica è chiusa (enable_signup=false lato GoTrue).
// Gli account nascono solo dall'attivazione web /attiva tramite invito. Questa
// pagina spiega all'utente come ottenere l'accesso, niente form self-service.
export function SignUpPage(): JSX.Element {
  return (
    <IonPage>
      <IonContent className="te-page">
        <div className="te-auth-shell" style={{ minHeight: '100%', display: 'flex', flexDirection: 'column',
          justifyContent: 'center', padding: '32px 24px', textAlign: 'center' }}>
          <div style={{ width: 64, height: 64, borderRadius: 18, margin: '0 auto 14px',
            background: 'linear-gradient(135deg, #0066cc, #8b5cf6)', color: '#fff', fontSize: 28,
            fontWeight: 700, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>TE</div>
          <h1 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 700, color: '#0f172a' }}>Serve un invito</h1>
          <p style={{ margin: '0 0 20px', fontSize: 14, color: '#475569', lineHeight: 1.5 }}>
            TrackEAT si attiva su invito. Se il tuo referente TrackEAT (o il tuo
            consulente) ti ha mandato un link via email, aprilo per impostare la
            password e scaricare l'app. Se hai già attivato l'account, accedi qui sotto.
          </p>
          <a className="ion-activatable" href="https://wa.me/393486382343?text=Ciao%2C%20vorrei%20attivare%20TrackEAT"
            target="_blank" rel="noreferrer"
            style={{ display: 'block', background: '#25d366', color: '#fff', padding: '14px 20px',
              borderRadius: 12, fontWeight: 700, textDecoration: 'none', marginBottom: 12 }}>
            Richiedi l'accesso su WhatsApp
          </a>
          <Link to="/auth/signin" style={{ color: '#0066cc', fontWeight: 600, textDecoration: 'none', fontSize: 14 }}>
            Ho già un account — Accedi
          </Link>
        </div>
      </IonContent>
    </IonPage>
  );
}
